import * as React from 'react';
import Button from 'material-ui/Button';
import appStyles, { StyleProps } from '../../utils/style';
import { connect, Dispatch } from 'react-redux';
import { Action, bindActionCreators } from 'redux';
import { AppState } from '../../store/reducers';
import { gotoSite } from '../../store/Navigation/navigation.actions';
import { getCurrentSite } from '../../store/Navigation/navigation.reducer';
import { withStyles } from 'material-ui/styles';
import { getEnvironmentFromUrl, URL_PRODCUTION } from '../../utils/url';
import IconOpenInNew from 'material-ui-icons/OpenInNew';

const styleSheet = appStyles;

export interface OwnProps {
  title: string;
  destination?: string;
  cmsNextUrl?: string;
  style?: object;
  onClick?: (destination: string) => void;
}

interface StateProps {
  currentSite?: string;
}

type Props = OwnProps & DispatchProps & StateProps & StyleProps;

const handleWindowOpen = (urlPath: string): void => {
  const baseUrl = getEnvironmentFromUrl() === URL_PRODCUTION
    ? 'https://aboutyou.content.aboutyou.cloud'
    : 'https://aboutyou.content.staging.aboutyou.cloud';

  window.open(`${baseUrl}${urlPath}`, '_blank');
};

class NavButton extends React.PureComponent<Props, {}> {
  private handleClick(destination: string) {
    const { onClick, onClickNavLink } = this.props;
    if (onClick) {
      onClick(destination);
    } else {
      onClickNavLink(destination);
    }
  }
  public render() {
    const { currentSite, destination, cmsNextUrl, title, style } = this.props;

    return (
      <Button
        onClick={() => cmsNextUrl
          ? handleWindowOpen(cmsNextUrl)
          : this.handleClick(destination!)}
        variant={currentSite === destination ? 'raised' : 'flat'}
        style={style ? style : void 0}
      >
        {title}
        {cmsNextUrl && (<IconOpenInNew style={{ fontSize: 14, marginLeft: 4 }} />)}
      </Button>
    );
  }
}

interface DispatchProps {
  onClickNavLink: typeof gotoSite;
}

const mapDispatch = (dispatch: Dispatch<Action>): DispatchProps => {
  return bindActionCreators(
    {
      onClickNavLink: gotoSite,
    },
    dispatch
  );
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    currentSite: getCurrentSite(state),
  };
};

export default withStyles(styleSheet)(
  connect(
    mapStateToProps,
    mapDispatch
  )(NavButton)
);



// WEBPACK FOOTER //
// ./src/modules/NavButton/index.tsx